import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'

const ProgressIndicator = ({ value, color = 'primary' }) => {
  return (
    <LinearProgress
      value={value}
      color={color}
      variant="determinate"
      style={{
        height: '.625rem',
        position: 'absolute',
        width: '100vw',
        left: 0,
        top: '4rem',
      }}
    />
  )
}

export default ProgressIndicator
